import styled from 'styled-components';
import MuiPagination from '@mui/material/Pagination';

export const Pagination = styled(MuiPagination)`
  .MuiButtonBase-root {
    color: ${(props) => props.theme.palette.text.primary};

    &.Mui-selected,
    &:hover {
      color: #fff;
      background-color: ${(props) => props.theme.primary.main};
    }
  }
`;
